<template>
  <div>
    <div class="box">
      <vue-element-loading :active="isLoading" spinner="spinner" />
      <div class="field has-addons has-text-centered is-vcentered">
        <button
          class="mt-1 button is-rounded is-white is-small"
          @click="getPrev()"
        >
          <i class="fas fa-chevron-left"></i>
        </button>
        <button
          class="mt-1 button is-rounded is-white is-small"
          @click="getNext()"
        >
          <i class="fas fa-chevron-right"></i>
        </button>
        <h5 class="title is-5 ml-3 mt-2">
          {{ year }} {{ $t("reports.year") }}
        </h5>
      </div>
      <div class="mb-2 ml-4">
        <label class="checkbox">
          <input
            type="checkbox"
            v-model="showShortDeviceName"
            @click="changeshowShortDeviceName()"
          />
          {{ $t("dashboard.showShortDeviceName") }}
        </label>
      </div>
      <div class="table-container">
        <table
          class="table narrower is-fullwidth table-container has-text-centered weekly-report"
        >
          <thead>
            <tr>
              <th v-for="(item, index) in tableHeader" v-bind:key="index">
                {{ item }}
              </th>
              <th>{{ $t("reports.total") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in aggrList" v-bind:key="index">
              <td>
                <router-link
                  :to="{
                    name: 'dataView',
                    params: {
                      projectId: projectId,
                      deviceId: index,
                    },
                  }"
                >
                  {{ index }}
                </router-link>
              </td>
              <td>
                <span
                  v-if="showShortDeviceName"
                  :data-tooltip="deviceList[index].name"
                >
                  {{ deviceList[index].shotName }}
                </span>
                <span v-else>
                  {{ deviceList[index].name }}
                </span>
              </td>
              <td v-for="(v, i) in item" v-bind:key="i" :class="v.color">
                {{ v.count }}
              </td>
              <td>{{ totalList[index] }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import imsr from "@/imsr-api";
import { ref } from "vue";
import VueElementLoading from "vue-element-loading";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  components: {
    VueElementLoading,
  },
  props: {
    tenantId: {
      type: String,
      required: true,
    },
    projectId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const router = useRouter();
    const store = useStore();
    const { t } = useI18n();
    const aggrList = ref();
    const totalList = ref();
    const isLoading = ref(false);
    const deviceList = ref();
    const tableHeader = ref([]);
    const year = ref(null);
    const nextYear = ref(null);
    const prevYear = ref(null);
    const showShortDeviceName = ref(true);
    const getList = async () => {
      try {
        if (year.value == null) {
          let y = new Date();
          year.value = y.getFullYear();
        }
        nextYear.value = year.value + 1;
        prevYear.value = year.value - 1;
        const params = {
          tenantId: props.tenantId,
          projectId: props.projectId,
          startDate: year.value.toString() + "01",
          endDate: year.value.toString() + "12",
        };
        const res = await imsr.imsrGetApi("/events/month", params);
        let data = {};
        let total = [];
        tableHeader.value = [t("devices.deviceId"), t("devices.deviceLocate")];
        res.years[0].months.forEach(function(month) {
          tableHeader.value.push(month.month.toString() + t("reports.month"));
          month.devices.forEach(function(device) {
            if (!data[device.deviceId]) {
              data[device.deviceId] = [];
            }
            if (!total[device.deviceId]) {
              total[device.deviceId] = 0;
            }
            total[device.deviceId] += device.count;
            let color = "";
            if (device.count >= 150) {
              color = "imsr-danger";
            } else if (device.count > 0) {
              color = "imsr-warning";
            }
            data[device.deviceId].push({
              count: device.count,
              color: color,
            });
          });
        });
        aggrList.value = data;
        totalList.value = total;
        isLoading.value = false;
      } catch (e) {
        router.push({ name: "InternalServerError" });
      }
    };
    getList();

    const getDevice = async () => {
      try {
        const params = {
          tenantId: props.tenantId,
          projectId: props.projectId,
        };
        const res = await imsr.imsrGetApi("/devices/list", params);
        let data = [];
        res.forEach(function(val) {
          data[val.deviceId] = {
            name: val.deviceLocate,
            shotName: val.deviceLocate.substring(0, 6),
          };
        });
        deviceList.value = data;
      } catch (e) {
        router.push({ name: "InternalServerError" });
      }
    };
    getDevice();

    const loadshowShortDeviceName = () => {
      showShortDeviceName.value = store.getters.showShortDeviceName ?? true;
    };
    loadshowShortDeviceName();

    const getPrev = () => {
      year.value = prevYear.value;
      getList();
    };

    const getNext = () => {
      year.value = nextYear.value;
      getList();
    };

    const changeshowShortDeviceName = () => {
      showShortDeviceName.value = !showShortDeviceName.value;
      store.commit("setshowShortDeviceName", showShortDeviceName.value);
    };

    return {
      aggrList,
      isLoading,
      year,
      tableHeader,
      deviceList,
      totalList,
      getPrev,
      getNext,
      showShortDeviceName,
      changeshowShortDeviceName,
    };
  },
};
</script>
<style>
.weekly-report {
  font-size: 95%;
}
.imsr-warning {
  background-color: rgb(255, 246, 97);
}
.imsr-danger {
  background-color: rgb(255, 137, 127);
}
</style>
